import path from 'path';
import { Action } from '@reduxjs/toolkit';

export const RESET_STORE = path.join(__dirname, 'resetStore');
export function resetStore(): Action<typeof RESET_STORE> {
  return { type: RESET_STORE };
}
